import React from 'react';
import { BaseComponentProps } from '../../types/common';
import { clsx } from 'clsx';

interface CardProps extends BaseComponentProps {
  hover?: boolean;
  padding?: 'sm' | 'md' | 'lg' | 'xl';
  border?: boolean;
  shadow?: 'sm' | 'md' | 'lg' | 'xl';
}

export const Card: React.FC<CardProps> = ({
  children,
  className,
  hover = true,
  padding = 'md',
  border = true,
  shadow = 'md',
  ...props
}) => {
  const baseClasses = 'bg-surface rounded-lg transition-all duration-250';
  
  const hoverClasses = hover
    ? 'hover:transform hover:-translate-y-1 hover:shadow-xl'
    : '';
  
  const paddingClasses = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
    xl: 'p-10',
  };
  
  const borderClasses = border
    ? 'border border-border'
    : '';
  
  const shadowClasses = {
    sm: 'shadow-sm',
    md: 'shadow-md',
    lg: 'shadow-lg',
    xl: 'shadow-xl',
  };
  
  const cardClasses = clsx(
    baseClasses,
    hoverClasses,
    paddingClasses[padding],
    borderClasses,
    shadowClasses[shadow],
    className
  );

  return (
    <div className={cardClasses} {...props}>
      {children}
    </div>
  );
};